import React, { useState } from "react";
import { Alert, Button, Form, Modal, Row, Table } from "react-bootstrap";
import { myGlobals, myUtilities } from "../Utils";
import { callReduxConfirmAlertAction } from "../App";
import { renderCell } from "./partialPaymentHelpers";

const CompleteInvoiceDrawer = ({ showDrawer, setShowDrawerFlag, invData }) => {
  const [searchField, setSearchField] = useState("");
  const onSearchField = ({ target: { value } }) => setSearchField(value);

  let selectedIndices = invData.generateSelectedIndices();
  
  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");

  const triggerTempAlert = (alertKey, alertMessage) => {
    setAlertMsg(myUtilities.accountSpecificLanguage(alertKey, alertMessage));
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 3000);
  };

  const clickHandler = (pos,setShowAlert) => {
    if (!invData.state.allowInvoiceExclusion) return;
    if(!myGlobals.invoiceSelectionAllowed) {
        callReduxConfirmAlertAction(
          "Alert.InvoiceSelectionPayMethod",
          "You are already on the payment page. Are you sure you want to reset your payment details?"
        );
        return;
      }
    if (!(selectedIndices.includes(pos) && selectedIndices.length === 1)) {
      if (selectedIndices.includes(pos))
        selectedIndices = myUtilities.removeArrayElement(selectedIndices, pos);
      else selectedIndices.push(pos);
    } else triggerTempAlert('Alert.DeSelectLastInvoice', 'Please select atleast one invoice to proceed');
    invData.updateSelectedInvoices(selectedIndices.sort(),triggerTempAlert);
  };

  return (
    <Modal
      className="complete"
      dialogClassName="complete-grid-drawer"
      show={showDrawer}
      onHide={() => {
		  			 setShowDrawerFlag(false);
      				 setSearchField("");
      }}
      aria-labelledby="modal-label"
      style={{ position: "fixed", top: 0 }}
    >
      <Modal.Header closeButton>
        <Modal.Title as="h5">
          {myUtilities.accountSpecificLanguage(
            "Header.SelectedInvoices",
            "Selected Paybale Invoices"
          )}{" "}
          ({invData.state.selectedInvoices?.length})
        </Modal.Title>
      </Modal.Header>
      {showAlert && (
              <Alert className="my-alert-class" variant="danger">
                <p>{alertMsg}</p>
              </Alert>
      )}
      <div className="drawer-content">
      <Form onSubmit={event=>event.preventDefault()}>
        <Row className="align-items-center">
          <Form.Control
            className="mb-2 search-icon"
            id="inlineFormInput"
            	placeholder={myUtilities.accountSpecificLanguage(
                        "InvoiceGrid.ModernUUX.SearchPlaceholder",
                        "Search by invoice number"
                      )}
            onChange={onSearchField}
          />
        </Row>
      </Form>
      <div className='table-container'> 
      <Table className='complete-drawer' >
        <thead>
          <tr
            onClick={() => invData.toggleSelctedInvoices(triggerTempAlert)}
            className="table-header"
          >
            <th style={{ minWidth: '20px', padding:'2px' }}> 
              <div className="checkboxOne">
                <input
                  checked={
                    invData.state.selectedInvoices?.length ===
                    invData.state.invoices?.length
                  }
                  type="checkbox"
                  value="1"
                  id="checkboxOneInput"
                  name=""
                />
                <label for="checkboxOneInput"></label>
              </div>
            </th>
            {invData.state.gridFields &&
              invData.state.gridFields.map((item, idxGrid) => (
                <th style={{padding:'2px' }} key={idxGrid}>
                  {myUtilities.accountSpecificLanguage(
                    "invoicegrid.header.label." + item[0],
                    item[1]
                  )}
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {invData.state.invoices &&
            invData.state.invoices
              .filter((el) => el.invoiceNumber.includes(searchField))
              .map((invoiceItem, index) => (
                <tr key={index} onClick={() => clickHandler(index,setShowAlert)}>
                  <td style={{ minWidth: '20px', padding:'2px' }}>
                    <div className="checkboxOne">
                      <input
                        checked={selectedIndices.includes(index)}
                        type="checkbox"
                        value="1"
                        id="checkboxOneInput"
                        name=""
                      />
                      <label for="checkboxOneInput"></label>
                    </div>
                  </td>
                  {invData.state.gridFields &&
                    invData.state.gridFields.map((item, gridIdx) =>
                      renderCell(item, gridIdx, invoiceItem, invData)
                    )}
                </tr>
              ))}
        </tbody>
      </Table></div>
     
      </div>
      <div className="Selection-control">
      <div>
        {myUtilities.accountSpecificLanguage("Header.totalamt", "Total Amount")}
        <br />{" "}
        <span className='payable-amt'>
        {myUtilities.needCurrency("total") +
          myUtilities.toStringUtil(invData.state.total, "total")}</span>
          </div>
          <Button
              	className="invoice-exclusion-grid-button"
               
                variant="primary"
                onClick={() => {
					setSearchField("");
					setShowDrawerFlag(false);
					}}
              >
                {myUtilities.accountSpecificLanguage("InvoiceGrid.Close", "Close")}
              </Button>
      </div>
    </Modal>
  );
};

export default CompleteInvoiceDrawer;
